






import { ErrorBox, Validator } from "@simonbackx/simple-error-forms";
import { SimpleError } from '@simonbackx/simple-errors';
import {DateTime} from 'luxon';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import DateSelection from "./DateSelection.vue"
import InputBox from "./InputBox.vue"


@Component({
    components: {
        InputBox,
        DateSelection
    }
})
export default class TimeInput extends Vue {
    @Prop({ default: "" })
    title: string;

    @Prop({ default: null })
    validator: Validator | null

    timeRaw = "";
    valid = true;

    @Prop({ required: true })
    value!: Date | null

    @Prop({ default: false })
    disabled!: boolean

    @Prop({ default: () => new Date() })
    defaultDate: Date

    @Prop({ default: "" })
    placeholder!: string

    @Prop({ default: "" })
    autocomplete!: string

    @Prop({default: ""})
    errorFields: string

    errorBox: ErrorBox | null = null

    @Watch('value')
    onValueChanged(val: Date | null) {
        if (val === null) {
            this.timeRaw = ""
            return
        }
        this.timeRaw = this.dateToHtmlTimeInput(val)
    }

    mounted() {
        if (this.validator) {
            this.validator.addValidation(this, () => {
                return this.validate()
            })
        }
        if (this.value === null) {
            this.timeRaw = ""
            return
        }
        this.timeRaw = this.dateToHtmlTimeInput(this.value)

    }

    destroyed() {
        if (this.validator) {
            this.validator.removeValidation(this)
        }
    }

    get dateValue() {
        return this.value
    }

    set dateValue(d: Date | null) {
        this.$emit("input", d)
    }

    validate() {
        this.timeRaw = this.timeRaw.trim().toLowerCase()

        const regex = /^([0-9]{1,2}:)?[0-9]{1,2}$/;

        if (!regex.test(this.timeRaw)) {
            this.errorBox = new ErrorBox(new SimpleError({
                "code": "invalid_field",
                "message": "Tijdstip ongeldig. Verwachte vorm: 14:30",
                "field": "time"
            }))
            return false

        } else {
            const split = this.timeRaw.split(":")
            let hours = parseInt(split[0])
            let minutes = parseInt(split[1] ?? "0")

            if (isNaN(hours)) {
                hours = 0;
            }

            if (isNaN(minutes)) {
                minutes = 0;
            }

            if (hours > 24 || minutes > 60) {
                this.errorBox = new ErrorBox(new SimpleError({
                    "code": "invalid_field",
                    "message": "Tijdstip ongeldig. Verwachte vorm: 14:30",
                    "field": "time"
                }))
                return false
            }
            if (hours < 9 || hours > 16 || (hours === 16 && minutes > 0)) {
                this.errorBox = new ErrorBox(new SimpleError({
                    "code": "invalid_field",
                    "message": "Tijdstip moet tussen 9:00 en 16:00 liggen",
                    "field": "time"
                }))
                return false
            }

            const d = new Date((this.value ?? this.defaultDate).getTime())
            d.setHours(hours, minutes, 0, 0)
            this.$emit("input", d)

            this.errorBox = null
            return true
        }
    }

    private dateToHtmlTimeInput(date: Date): string {
        return DateTime.fromJSDate(date).setZone('Europe/Brussels').toFormat('HH:mm')
    }
}
